// extracted by mini-css-extract-plugin
export default {"adCard":"eventCardSponsored__adCard__bkSkU"};